import { lazy } from 'react';

export const AddBrand = lazy(() => import('./brand/AddBrand'));
export const UpdateBrand = lazy(() => import('./brand/UpdateBrand'));
export const BrandList = lazy(() => import('./brand/BrandList'));
export const CategoryList = lazy(() => import('./category/CategoryList'));
export const AddCategory = lazy(() => import('./category/AddCategory'));
export const UpdateCategory = lazy(() => import('./category/UpdateCategory'));
export const VendorList = lazy(() => import('./vendor/VendorList'));
export const AddVendor = lazy(() => import('./vendor/AddVendor'));
export const UpdateVendor = lazy(() => import('./vendor/UpdateVendor'));
export const SubCategoryList = lazy(() => import('./subcategory/SubCategoryList'));
export const AddSubCategory = lazy(() => import('./subcategory/AddSubCategory'));
export const UpdateSubCategory = lazy(() => import('./subcategory/UpdateSubCategory'));
export const ItemList = lazy(() => import('./item/ItemList'));
export const AddItem = lazy(() => import('./item/AddItem'));
export const UpdateItem = lazy(() => import('./item/UpdateItem'));
export const SparePartsList = lazy(() => import('./spare_parts/SparePartsList'));
export const AddSpareParts = lazy(() => import('./spare_parts/AddSpareParts'));
export const UpdateSpareParts = lazy(() => import('./spare_parts/UpdateSpareParts'));
export const ToolsList = lazy(() => import('./tools/ToolsList'));
export const AddTools = lazy(() => import('./tools/AddTools'));
export const UpdateTools = lazy(() => import('./tools/UpdateTools'));
export const DepartmentList = lazy(() => import('./department/DepartmentList'));
export const AddDepartment = lazy(() => import('./department/AddDepartment'));
export const UpdateDepartment = lazy(() => import('./department/UpdateDepartment'));
export const ServiceDepartmentList = lazy(() => import('./service_department/ServiceDepartmentList'));
export const AddServiceDepartment = lazy(() => import('./service_department/AddServiceDepartment'));
export const UpdateServiceDepartment = lazy(() => import('./service_department/UpdateServiceDepartment'));
export const BlockList = lazy(() => import('./block/BlockList'));
export const AddBlock = lazy(() => import('./block/AddBlock'));
export const UpdateBlock = lazy(() => import('./block/UpdateBlock'));
export const LocationList = lazy(() => import('./location/LocationList'));
export const AddLocation = lazy(() => import('./location/AddLocation'));
export const UpdateLocation = lazy(() => import('./location/UpdateLocation'));
export const SubLocationList = lazy(() => import('./sub_location/SubLocationList'));
export const AddSubLocation = lazy(() => import('./sub_location/AddSubLocation'));
export const UpdateSubLocation = lazy(() => import('./sub_location/UpdateSubLocation'));
export const ShiftList = lazy(() => import('./shift/ShiftList'));
export const AddShift = lazy(() => import('./shift/AddShift'));
export const UpdateShift = lazy(() => import('./shift/UpdateShift'));
export const SlaAndPriorityList = lazy(() => import('./sla_and_priority/SlaAndPriorityList'));
export const AddSlaAndPriority = lazy(() => import('./sla_and_priority/AddSlaAndPriority'));
export const UpdateSlaAndPriority = lazy(() => import('./sla_and_priority/UpdateSlaAndPriority'));
export const TaskStatusList = lazy(() => import('./task_status/TaskStatusList'));
export const AddTaskStatus = lazy(() => import('./task_status/AddTaskStatus'));
export const UpdateTaskStatus = lazy(() => import('./task_status/UpdateTaskStatus'));
export const ReasonList = lazy(() => import('./reason/ReasonList'));
export const AddReason = lazy(() => import('./reason/AddReason'));
export const UpdateReason = lazy(() => import('./reason/UpdateReason'));
export const StaffList = lazy(() => import('./staff/StaffList'));
export const AddStaff = lazy(() => import('./staff/AddStaff'));
export const UpdateStaff = lazy(() => import('./staff/UpdateStaff'));
export const CountryList = lazy(() => import('./country/CountryList'));
export const StateList = lazy(() => import('./state/StateList'));
export const CityList = lazy(() => import('./city/CityList'));
export const InventoryUnitList = lazy(() => import('./inventory_unit/InventoryUnitList'));
export const AddInventoryUnit = lazy(() => import('./inventory_unit/AddInventoryUnit'));
export const UpdateInventoryUnit = lazy(() => import('./inventory_unit/UpdateInventoryUnit'));

export const MasterChecklistList = lazy(() => import('./master_checklist/MasterChecklistList'));
export const AddMasterChecklist = lazy(() => import('./master_checklist/AddMasterChecklist'));
export const UpdateMasterChecklist = lazy(() => import('./master_checklist/UpdateMasterChecklist'));